import React from 'react';
import { Content, Label } from '@patternfly/react-core';
import type { NetworkVlan } from '../../../types/models';

export const renderStatusLabel = (status: string | null): React.ReactNode => {
  if (status === null) return '—';
  switch (status) {
    case 'active':
      return <Label color="green">{status}</Label>;
    case 'reserved':
      return <Label color="orange">{status}</Label>;
    case 'deprecated':
      return <Label color="grey">{status}</Label>;
    case 'container':
      return <Label color="blue">{status}</Label>;
    default:
      return <Label>{status}</Label>;
  }
};

export const renderFamilyLabel = (family: number | null): React.ReactNode => {
  if (family === 4) return <Label color="blue">IPv4</Label>;
  if (family === 6) return <Label color="purple">IPv6</Label>;
  return '—';
};

export const renderVlan = (vlan: NetworkVlan | null): React.ReactNode => {
  if (vlan === null) return '—';
  return (
    <>
      {vlan.name}{' '}
      <Content component="small" className="pf-v6-u-color-200">
        (VID {vlan.vid})
      </Content>
    </>
  );
};

export const renderDescription = (description: string): React.ReactNode => (description === '' ? '—' : description);
